{
  "privacy-policy": "1.0",
  "term-of-use": "1.0",
  "code-of-conduct": "1.0",
  "cookie-policy": "1.0"
}
